import { VisualizationPage } from '@/features/visualization'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/scene-editor',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <VisualizationPage />
  )
}
